import { render } from "./InnovativeProduct.vue?vue&type=template&id=788a3b4d&scoped=true"
import script from "./InnovativeProduct.vue?vue&type=script&lang=js"
export * from "./InnovativeProduct.vue?vue&type=script&lang=js"

import "./InnovativeProduct.vue?vue&type=style&index=0&id=788a3b4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788a3b4d"]])

export default __exports__